(function () {
  /** Attach toggles to EVERY collection hero currently in the DOM */
  function applyReadMore(root = document) {
    root.querySelectorAll('[data-readmore-desc]').forEach(desc => {
      const id  = desc.dataset.readmoreDesc;
      const btn = root.querySelector(`[data-readmore-btn="${id}"]`);

      if (!btn || btn._wired) return;   // already initialised
      btn._wired = true;                // flag for future checks
      btn.hidden = false;

      btn.addEventListener('click', () => {
        const open = desc.classList.toggle('expanded');
        btn.textContent = open ? 'Show less' : 'Read more';
      });

      // Hide button for very short blurbs
      if (desc.textContent.trim().length < 140) btn.hidden = true;
    });
  }

  // 1) Initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyReadMore());
  } else {
    applyReadMore();
  }

  // 2) Broadcast / Shopify may inject new sections via AJAX
  document.addEventListener('shopify:section:load',  e => applyReadMore(e.target));
  document.addEventListener('shopify:section:select', e => applyReadMore(e.target));

  console.log('▶ read-more script initialised');
})();
